import React, { useState } from 'react'
import TabView from '../../tabview'
import { useSelector } from 'react-redux'
import AdminEvaluations from './AdminEvaluations'
import UnauthorizedPage from '../../../pages/errors/unauthorized'
import SupervisorEvaluations from './SupervisorEvaluations'
import AssignedEvaluations from './AssignedEvaluations'

const PerformanceTabs = () => {
  const [activeTab, setActiveTab] = useState(1)
  const { user } = useSelector((state) => state.userSlice)

  const Tabs = [
    {
      title: 'Assigned Evaluations',
      Content:
        user?.permissions.performance_permission.performance_read === 1 ||
        user?.permissions.company_permission.role === 'Owner'
          ? AssignedEvaluations
          : UnauthorizedPage,
    },
    {
      title: 'Admin Evaluations',
      Content:
        user?.permissions.performance_permission.performance_read === 1 ||
        user?.permissions.company_permission.role === 'Owner'
          ? AdminEvaluations
          : UnauthorizedPage,
    },
    {
      title: 'Supervisor Evaluations',
      Content:
        user?.permissions.performance_permission.performance_read === 1 ||
        user?.permissions.company_permission.role === 'Owner'
          ? SupervisorEvaluations
          : UnauthorizedPage,
    },
  ]

  return (
    <>
      <div className='mt-3'>
        <TabView
          Tabs={Tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </>
  )
}

export default PerformanceTabs
